import { Routes } from '@angular/router';
import { AnaUygulamaComponent } from './ana-uygulama/ana-uygulama.component';
import { uyelerGiremezGuard, uyeOlmayanGiremezGuard, GirisYapComponent, AramizaKatilComponent, SifreSifirlaComponent } from '@shared';

// Not: Remote'un ihtiyaç duyduğu provider'lar host (kabuk) app.config'inde
// RemoteSaglayicilar ile environment seviyesinde sağlanır. Route seviyesinde
// vermek child injector'da NG0201 (_DomRendererFactory2) üretiyordu.
// Not: Sayfa import'ları @shared BARREL üzerinden — native-federation yalnızca
// barrel sharedMapping kabul eder; alt path (subpath) specifier'ları runtime'da
// çözülemez ("Unable to resolve specifier").
// Portal girişi login gerektirir (eski sistemdeki kullanici.routes deseni).
export const routes: Routes = [
  {
    path: '',
    component: AnaUygulamaComponent,
    canActivate: [uyeOlmayanGiremezGuard],
  },
  {
    path: 'giris',
    component: GirisYapComponent,
    canActivate: [uyelerGiremezGuard],
    data: { baslik: 'Giriş Yap' },
  },
  {
    path: 'kayit',
    component: AramizaKatilComponent,
    canActivate: [uyelerGiremezGuard],
    data: { baslik: 'Aramıza Katıl' },
  },
  {
    path: 'sifre-sifirla',
    component: SifreSifirlaComponent,
    canActivate: [uyelerGiremezGuard],
    data: { baslik: 'Şifre Sıfırla' },
  },
];

